/* Define your initial state here.
 *
 * If you change the type from object to something else, do not forget to update
 * src/container/App.js accordingly.
 */
import {VIP_NOTIFICATION_SET_VALUE, VIP_NOTIFICATION_IS_SAVING_PUSH} from '../actions/const';

const initialState = {
	cardTypeOptions: [],
	cardType: null,
	specificUserOptions: [],
	specificUser: null,
	userTypeOptions: [
		{
			value: 'all',
			label: 'ALL'
		}, {
			value: 'member',
			label: 'MEMBER'
		}, {
			value: 'non-member',
			label: 'NON-MEMBER'
		}
	],
	userType: {
		value: 'all',
		label: 'ALL'
	},
	deviceOptions: [
		{
			value: 'all',
			label: 'ALL'
		}, {
			value: 'android',
			label: 'ANDROID'
		}, {
			value: 'ios',
			label: 'IOS'
		}
	],
	device: {
		value: 'all',
		label: 'ALL'
	},
	screenOptions: [],
	screen: null,
	browserOptions: [
		{
			value: 'internal',
			label: 'INTERNAL'
		}, {
			value: 'external',
			label: 'EXTERNAL'
		}
	],
	browser: null,
	subject: '',
	url: '',
	message: '',
	isSendNow: true,
	isScheduleNotif: false,
	scheduleDateTimeNotif: null,
	isSending: false,
	notifCount: 0,
	notifCountWithSchedule: 0
};

function reducer(state = initialState, action) {
	/* Keep the reducer clean - do not mutate the original state. */
	// const nextState = Object.assign({}, state);
	// console.log(action.payload)
	switch (action.type) {

		case VIP_NOTIFICATION_SET_VALUE:
			{
				// Modify next state depending on the action and return it
				return Object.assign({}, state, action.payload);
			}
		case VIP_NOTIFICATION_IS_SAVING_PUSH:
			{
				// Modify next state depending on the action and return it
				return Object.assign({}, state, {
					isSending: !isSending
				});
			}

		default:
			{
				/* Return original state if no actions were consumed. */
				return state;
			}
	}
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/NotificationVIP.js